import { getQuotingStatistics } from 'api/operations/electionService';
import { makeAutoObservable, runInAction } from 'mobx';
import { createContext, useContext } from 'react';
import { QuoteRouteV2Id } from 'routes/routesConfigV2';
import QuoteFlowDelegate, { QuoteFlowDomainParams } from 'store/flows/quote/quoteFlowDelegate';
import { QuotingStatistics } from 'types/electionService';
import { URLS } from '../../../../utils/urls';

export default class ZywaveRedirectPageStore {
  private _domainParams: QuoteFlowDomainParams;
  private _isActionLoading = false;

  public readonly flowDelegate: QuoteFlowDelegate;

  private _quotingStatistics: QuotingStatistics | null = null;

  public get quotingStatistics(): QuotingStatistics | null {
    return this._quotingStatistics;
  }

  public get isActionLoading(): boolean {
    return this._isActionLoading;
  }

  public get canCompleteStep(): boolean {
    return !this._isActionLoading && !this.flowDelegate.isInitialDataLoading;
  }

  private _setActionLoading(isLoading: boolean): void {
    this._isActionLoading = isLoading;
  }

  public async getInitialData(): Promise<void> {
    this.flowDelegate.setIsInitialDataLoading(true);
    await this.flowDelegate.getFlowInitialData();
    const stats = await getQuotingStatistics(this._domainParams.groupId, this._domainParams.cartId);
    runInAction(() => {
      this._quotingStatistics = stats;
    });
    this.flowDelegate.setIsInitialDataLoading(false);
  }

  public onComplete(): void {
    this._setActionLoading(true);
    window.location.href = `https://${URLS.zywaveRedirect}/post-quote-redirect?groupId=${this._domainParams.groupId}&proposalId=${this._domainParams.cartId}`;
  }

  constructor(params: QuoteFlowDomainParams) {
    this._domainParams = params;
    this.flowDelegate = new QuoteFlowDelegate({
      domainParams: params,
      // Should not be actually used.
      nextPageId: QuoteRouteV2Id.ZYWAVE_QUOTE_REDIRECT,
    });
    makeAutoObservable(this, {}, { autoBind: true });
  }
}

const ZywaveRedirectPageStoreContext = createContext(new ZywaveRedirectPageStore({} as QuoteFlowDomainParams));

export const useZywaveRedirectPageStore = (): ZywaveRedirectPageStore => {
  return useContext(ZywaveRedirectPageStoreContext);
};

export { ZywaveRedirectPageStore, ZywaveRedirectPageStoreContext };
